export default "__VITE_ASSET__B$Sw1MS___"